import { z } from 'zod'

export const componentSchema = z.object({
  name: z.string().min(1, { message: 'Name field is required' }),
  description: z.string().min(1, { message: 'Description field is required' }),
  collectionId: z.string()
})
